const orderStatus = [
    "pending",
    "confirm",
    // "order packed",
    // "out for delivery",
    // "delivered",
    "decline",
];

export const OrderStatus = orderStatus.map((status) => status.toUpperCase());

export const classNames = (...classes: Array<string | undefined | null | false>) => {
  return classes.filter(Boolean).join(" ");
};
